import { render } from "./Metadata.vue?vue&type=template&id=d9444200&scoped=true&ts=true"
import script from "./Metadata.vue?vue&type=script&lang=ts"
export * from "./Metadata.vue?vue&type=script&lang=ts"

import "./Metadata.vue?vue&type=style&index=0&id=d9444200&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9444200"]])

export default __exports__